import { DatePipe, Location } from '@angular/common';
import { HttpClientModule, HttpHandler, HttpInterceptor, HttpRequest, HTTP_INTERCEPTORS } from '@angular/common/http';
import { APP_INITIALIZER, Injectable, LOCALE_ID, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbModalModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ToastrModule } from 'ngx-toastr';
import { CurrentLanguage } from 'projects/Autofacets-Core/src/app/common-services/current-language.service';
import { EnvSetting } from 'projects/Autofacets-Core/src/app/utils/env-setting';
import { AutofacetsCoreModule } from '../../../Autofacets-Core/src/app/app.module';
import { CultureLocaleService } from '../app/Services/culture/culture-locale.service';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FooterSiteInfoComponent } from './footer-site-info/footer-site-info.component';
import { FullOrderDetailsComponent } from './full-order-details/full-order-details.component';
import { HeaderComponent } from './header/header.component';
import { ThemeDirective } from './helper/directive/theme.directive';
import { JwtAppInterceptor } from 'projects/Autofacets-Core/src/app/interceptor/jwt-app.interceptor';
import { GlobalService } from './helper/Services/global.service';
import { InitApp } from './helper/Services/init-app';
import { SecureStorage } from './helper/Services/secure-storage';
import { CurrencySymbolSpacePipe } from './Pipes/currency-symbol-space.pipe';
import { MaskEmailPipe } from './Pipes/mask-email.pipe';
import { NumberMaskPipe } from './Pipes/mask-phone.pipe';
import { CustomLoader } from './Services/customloader/custom-loader.service';
import { CommonLocalizationService } from './Services/localization/common-localization.service';
import { CarParkingComponent } from './Views/car-parking/car-parking.component';
import { ErrorPageComponent } from './Views/error-page/error-page.component';
import { NotificationComponent } from './Views/notification/notification.component';
import { ViewNotificationComponent } from './Views/notification/view-notification/view-notification.component';
import { AdditionalServiceInfoComponent } from './Views/order-status/additional-service-info/additional-service-info.component';
import { DealerInformationComponent } from './Views/order-status/dealer-information/dealer-information.component';
import { OrderStatusComponent } from './Views/order-status/order-status.component';
import { VehicleOrderComponent } from './Views/order-status/vehicle-order/vehicle-order.component';
import { VehicleStatusComponent } from './Views/order-status/vehicle-status/vehicle-status.component';
import { PdfViewComponent } from './Views/pdf-view/pdf-view.component';
import { RegValidationComponent } from './Views/reg-validation/reg-validation.component';
import { ViewAllNotificationsComponent } from './Views/notification/view-all-notifications/view-all-notifications/view-all-notifications.component';
import { ViewNotificationDetailsComponent } from './Views/notification/view-all-notifications/view-notification-details/view-notification-details.component';
import { NotificationViewComponent } from './Views/notification/view-all-notifications/notification-view/notification-view.component';
import { ModalDialogComponent } from './Views/modal-dialog/modal-dialog.component'
import { MockTranslateDirective } from './Services/mock-translate.directive';
import { AfDirectiveModule } from 'projects/Autofacets-Core/src/app/directives/af-directive-core.module';
import { GoogleMapsModule } from '@angular/google-maps';

export function createTranslateLoader(commonLocalizationService: CommonLocalizationService) {
 return new CustomLoader(commonLocalizationService);
}
@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterSiteInfoComponent,
    OrderStatusComponent,
    VehicleOrderComponent,
    VehicleStatusComponent,
    DealerInformationComponent,
    NotificationComponent,
    CarParkingComponent,
    ViewNotificationComponent,
    ErrorPageComponent,
    ThemeDirective,
    PdfViewComponent,
    MaskEmailPipe,
    NumberMaskPipe,
    CurrencySymbolSpacePipe,
    AdditionalServiceInfoComponent,
    RegValidationComponent,
    FullOrderDetailsComponent,
    ViewAllNotificationsComponent,
    ViewNotificationDetailsComponent,
    NotificationViewComponent,
    ModalDialogComponent,
    MockTranslateDirective
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot(),
    AppRoutingModule,
    NgbModalModule,
    NgbModule,
    FormsModule,
    HttpClientModule,
    NgSelectModule,
    AutofacetsCoreModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [CommonLocalizationService]
      }
    }),
    NgxSpinnerModule,
    GoogleMapsModule,
    AfDirectiveModule
  ],
  providers: [
    ThemeDirective,
    DatePipe,
    { provide: HTTP_INTERCEPTORS, useClass: JwtAppInterceptor, multi: true },
    CurrentLanguage,
    CultureLocaleService,
    {
      provide: APP_INITIALIZER,
      useFactory: InitApp,
      multi: true,
      deps: [Location, GlobalService, CultureLocaleService, SecureStorage]
    },
    { 
      provide: LOCALE_ID, 
      deps: [CultureLocaleService],
      // tslint:disable-next-line:no-shadowed-variable
      useFactory: (cultureLocaleService: any) => cultureLocaleService.getLocale()
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
